export interface Palette {
  readonly background: string;
  readonly gridMinor: string;
  readonly gridMajor: string;
  readonly axisX: string;
  readonly axisY: string;
  readonly entity: string;
  readonly hover: string;
  readonly selection: string;
  readonly preview: string;
  readonly snap: string;
  readonly marquee: string;
  readonly marqueeFill: string;
  readonly text: string;
}

export const LIGHT_PALETTE: Palette = {
  background: '#ffffff',
  gridMinor: '#ececf1',
  gridMajor: '#d8d8e2',
  axisX: '#d2707099',
  axisY: '#70a07099',
  entity: '#1b1b1f',
  hover: '#3b5bdb',
  selection: '#f08c00',
  preview: '#3b5bdb',
  snap: '#0b7285',
  marquee: '#3b5bdb',
  marqueeFill: '#3b5bdb18',
  text: '#55555f',
};

export const DARK_PALETTE: Palette = {
  background: '#131316',
  gridMinor: '#1f1f26',
  gridMajor: '#2c2c36',
  axisX: '#a8474799',
  axisY: '#4c8a5299',
  entity: '#e6e6ec',
  hover: '#7c93f5',
  selection: '#ffa94d',
  preview: '#7c93f5',
  snap: '#66d9e8',
  marquee: '#7c93f5',
  marqueeFill: '#7c93f522',
  text: '#a0a0ab',
};

export const paletteFor = (dark: boolean): Palette => (dark ? DARK_PALETTE : LIGHT_PALETTE);
